import { sendToFlutter } from "~/pages/_app";

export const openAppSettings = () => {
  sendToFlutter({ action: "OPEN_APP_SETTINGS" });
};

export const closeWebView2 = () => {
  sendToFlutter({ action: "CLOSE_WEBVIEW_2" });
};

export const openWebView2 = (url: string) => {
  sendToFlutter({ action: "OPEN_WEB_VIEW2", value: url });
};

export const showSnackbar = (message: string) => {
  sendToFlutter({ action: "SHOW_SNACKBAR", value: message });
};

export const showSnackbarWithTitle = (title: string, message: string) => {
  sendToFlutter({
    action: "SHOW_SNACKBAR_WITH_TITLE",
    value: { title, message },
  });
};

export const startBackground = () => {
  sendToFlutter({ action: "START_BACKGROUND" });
};

export const endBackground = () => {
  sendToFlutter({ action: "END_BACKGROUND" });
};

export const checkBluetooth = () => {
  sendToFlutter({ action: "CHECK_BLUETOOTH" });
};

export const checkLocationPermission = () => {
  sendToFlutter({ action: "CHECK_LOCATION_PERMISSION" });
};

export const runRegPetMenu = () => {
  sendToFlutter({ action: "RUN_REG_PET_MENU" });
};

export const getOs = () => {
  sendToFlutter({ action: "GET_OS" });
};

export const fcmClear = () => {
  sendToFlutter({ action: "FCM_CLEAR" });
};

export const fcmSubscribe = (topic: string) => {
  sendToFlutter({ action: "FCM_SUBSCRIBE", value: topic });
};

export const setUserId = (userId: string) => {
  sendToFlutter({ action: "SET_USER_ID", value: userId });
};

export const runQrScan = () => {
  sendToFlutter({ action: "RUN_QR_SCAN" });
};

export const runRegPet = () => {
  sendToFlutter({ action: "RUN_REG_PET" });
};

export const runRegDevice = (petId: number) => {
  sendToFlutter({ action: "RUN_REG_DEVICE", value: petId.toString() });
};

export const getAppVersion = () => {
  sendToFlutter({ action: "GET_APP_VERSION" });
};

export const getMyLocation = () => {
  sendToFlutter({ action: "GET_MY_LOCATION" });
};

export const getMyLocationPoop = () => {
  sendToFlutter({ action: "GET_MY_LOCATION_POOP" });
};

export const getWalkInfo = () => {
  sendToFlutter({ action: "GET_WALK_INFO" });
};

export const startStreamBeacon3 = () => {
  sendToFlutter({ action: "START_STREAM_BEACON3" });
};

export const startStreamBeacon = (uuids: string[]) => {
  // if (uuids.length) {
  sendToFlutter({ action: "START_STREAM_BEACON", value: uuids });
  // }
};

export const startStreamBeacon2 = () => {
  sendToFlutter({ action: "START_STREAM_BEACON2" });
};

export const endStreamBeacon = () => {
  sendToFlutter({ action: "END_STREAM_BEACON" });
};

export const startWalk = () => {
  sendToFlutter({ action: "START_WALK" });
};

export const endWalk = () => {
  sendToFlutter({ action: "END_WALK" });
};

export const runLoading = () => {
  sendToFlutter({ action: "RUN_LOADING" });
};

export const stopLoading = () => {
  sendToFlutter({ action: "STOP_LOADING" });
};
